import React from 'react';

export const WordCounter = ({ value = '', maxWords, maxChars, className = '' }) => {
  const charCount = value.length;
  const wordCount = value.trim() ? value.trim().split(/\s+/).filter(w => w).length : 0;
  
  // Calculate percentage based on words if maxWords is set, otherwise use chars
  let percentage = 0;
  let displayText = '';
  
  if (maxWords) {
    percentage = (wordCount / maxWords) * 100;
    displayText = `${wordCount} / ${maxWords} words`;
  } else if (maxChars) {
    percentage = (charCount / maxChars) * 100;
    displayText = `${charCount} / ${maxChars} characters`;
  } else {
    displayText = `${wordCount} words`;
  }
  
  // Add character count if word limit is used
  if (maxWords && maxChars) {
    displayText += ` (${charCount} characters)`;
  }
  
  // Determine color based on percentage
  let colorClass = 'text-gray-500';
  if (percentage >= 100) {
    colorClass = 'text-red-600 font-semibold';
  } else if (percentage >= 90) {
    colorClass = 'text-orange-500 font-medium';
  }
  
  return (
    <p className={`text-xs mt-1 ${colorClass} ${className}`} data-testid="word-counter">
      {displayText}
    </p>
  );
};

export default WordCounter;